import { TPanelData } from '../types';

export const getColumnAreas = (specificPanel: TPanelData) => {
  return {
    top: {
      top: specificPanel.panelTop,
      bottom: specificPanel.panelTop + specificPanel.panelHeight / 2,
      left: specificPanel.panelLeft,
      right: specificPanel.panelRight,
    },
    bottom: {
      top: specificPanel.panelBottom - specificPanel.panelHeight / 2,
      bottom: specificPanel.panelBottom,
      right: specificPanel.panelRight,
      left: specificPanel.panelLeft,
    },
  };
};
